<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 text-center>
        <div><b>{{ $t('b') }}</b></div>
        <div class="mt-1">
          <small>
            {{ $t('c') }}
            <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a>
          </small>
        </div>
      </v-flex>
      <v-flex xs12 v-if="isLoading" class="mt-6">
        <v-layout wrap justify-center>
          <v-flex xs6>
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <vue-calendly :url="url" :height="windowHeight" :key="keyForReload"></vue-calendly>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data: () => ({
    isShowingCalendlyDialog: false,
    keyForReload: 0,
    isLoading: true
  }),
  mounted() {
    setTimeout(() => {
      this.isLoading = false
    }, 2000)
  },
  computed: {
    urlParamFrom() {
      return this.$route.query.from
    },
    urlParamLang() {
      return this.$route.query.lang
    },
    url() {
      return 'https://calendly.com/esnwebservices/demo?primary_color=00c853'
      // if (this.urlParamLang === 'en') {
      //   return 'https://calendly.com/esnwebservices/demo-english?primary_color=00c853'
      // } else {
      //   return 'https://calendly.com/esnwebservices/demo?primary_color=00c853'
      // }
    },
    windowHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      return height
    }
  },
  watch: {
    urlParamLang: {
      handler() {
        this.keyForReload += 1
      }
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "bookDemo": "Planifier une démo",
    "b": "Pour créer un environnement pour votre entreprise, discutons ensemble en vidéoconférence.",
    "c": "ou contactez-nous à"
  },
  "en": {
    "bookDemo": "Book a demo",
    "b": "To create an environment for your company, let's make a quick video call.",
    "c": "or contact us at"
  }
}
</i18n>